<template>

  <modal id="formulario-documentacao" titulo="Gerenciamento de Documentação" :loading="!form">

    <template v-if="!auditoria">
      <card>

        <div class="row gutters-xs form">

          <v-input type="text" :readonly="true" label="Código" class="col-2" v-model="form.codigo" v-if="form.id"/>
          <v-input type="select" :options="tipos" label="Tipo" class="col-3"
                   v-model="form.tipo" :error="validation.tipo"/>
          <v-input type="date" class="col-4" label="Vencimento"
                   v-model="form.vencimento" :error="validation.vencimento"/>
          <v-input :error="validation.ativo" :required="true" class="col-auto"
                   label="Registro Ativo" type="radio" v-model="form.ativo"/>

          <div class="w-100"/>
          <v-input type="text" class="col-4" label="Nº Ordem"
                   v-model="form.numero" :error="validation.numero"/>
          <template v-if="isTipoComCamposCartorariosBase">
            <v-input type="date" class="col-4" label="Lavratura"
                     v-model="form.lavratura" :error="validation.lavratura"/>
          </template>
          <template v-if="isProcuracaoOrEscritura">
            <v-input type="text" class="col-4" label="Livro"
                     v-model="form.livro" :error="validation.livro"/>
            <div class="w-100"/>
            <v-input type="text" class="col-4" label="Folha Inicial"
                     v-model="form.folhaInicial" :error="validation.folhaInicial"/>
            <v-input type="text" class="col-4" label="Folha Final"
                     v-model="form.folhaFinal" :error="validation.folhaFinal"/>
          </template>
          <template v-if="isEscritura">
            <v-input type="text" class="col-4" label="Espécie"
                     v-model="form.especie" :error="validation.especie"/>
            <div class="w-100"/>
            <v-input type="v-select" class="col-12" label="Serventia" :options="serventias"
                     v-model="form.serventia" :error="validation.serventia"/>
          </template>
          <template v-if="isInstrumentoParticular">
            <v-input type="text" class="col-8" label="Instituição"
                     v-model="form.instituicao" :error="validation.instituicao"/>
          </template>
          <template v-if="isContratoSocial">
            <v-input type="text" class="col-4" label="Nº Registro"
                     v-model="form.numeroRegistro" :error="validation.numeroRegistro"/>
            <v-input type="date" class="col-6" label="Data Registro"
                     v-model="form.registro" :error="validation.registro"/>
          </template>

          <v-input type="date" class="col-6" label="Data de Arquivamento"
                   v-model="form.arquivamento" :error="validation.arquivamento"/>
          <div class="w-100"/>

          <v-input class="col-12" :error="validation.descricao"
                   v-model="form.descricao" type="textarea" label="Observação" />

        </div>

      </card>

      <anexos-wrapper nome="Documentação" entidade="DOCUMENTACAO" tipo-entidade="DOCUMENTACAO" :id="form.id" v-if="form.id" :digitalizacao="true" />

      <card titulo="Envolvidos">
        <card-table>

          <thead>
          <tr>
            <th>Nome</th>
            <th width="220px">Papel</th>
            <th width="150px">Documento</th>
            <th width="30px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(pessoa, i) in form.envolvidos" :key="pessoa.id">
            <td>{{pessoa.nome}}</td>
            <td>
              <v-input v-model="pessoa.papel" type="v-select" ref="papel" :options="papeis" />
            </td>
            <td>{{pessoa.indicadorPessoalVersao.documento}}</td>
            <td>
              <v-button :run="remover" :params="[i, 'envolvidos']" :button="false" :popover="true" class="icon" position="dropleft">
                <i class="fal fa-times" title="Excluir"></i>
              </v-button>
            </td>
          </tr>
          <tr>
            <td colspan="100%">
              <buscar-pessoa @add="addEnvolvido($event)" class="mt-2" :novo="true" />
            </td>
          </tr>
          </tbody>

        </card-table>
      </card>
      <card titulo="Documentações Relacionadas">
        <card-table class="mb-0">
          <thead>
          <tr>
            <th width="30px"></th>
            <th>Código</th>
            <th width="30px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(documentacao, i) in form.documentacoes" :key="documentacao.id">
            <td>
              <a title="Editar" class="icon" @click.prevent="formulario(documentacao)"><i class="fal fa-edit"></i></a>
            </td>
            <td>
              <a>Documentação {{documentacao.codigo}}</a>
            </td>
            <td><a @click.prevent="remover(i, 'documentacoes')" class="icon"><i class="fa fa-times"></i></a></td>
          </tr>
          <tr>
            <td colspan="100%">
              <div class="row">
                <buscar-documentacao ref="buscarFichas" :tipo="form.tipo"
                                     :multiplos="true"
                                     :limparCampo="true"
                                     @selecionar="selecionar($event, 'documentacoes')"
                                     class="col"/>
              </div>
            </td>
          </tr>
          </tbody>

        </card-table>
      </card>
      <card titulo="Protocolos Relacionados">
        <card-table class="mb-0">
          <thead>
          <tr>
            <th width="30px"></th>
            <th>Protocolo</th>
            <th width="30px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(protocoloItem, i) in form.protocolos" :key="protocoloItem.id">
            <td width="30px" class="text-center">
              <router-link :to="{ name: 'protocolo', params:{id : protocoloItem.id} }" class="icon" target="_blank" @click.native="$event.stopImmediatePropagation()">
                <i class="fas fa-external-link-alt"></i>
              </router-link>
            </td>
            <td>{{nomearProtocolo(protocoloItem.dominio, protocoloItem.tipoProtocolo, protocoloItem.codigo)}} - {{protocoloItem.tipoServico}}</td>
            <td><a @click.prevent="remover(i, 'protocolos')" class="icon"><i class="fa fa-times"></i></a></td>
          </tr>
          <tr >
            <td colspan="100%">
              <buscar-protocolos ref="buscarProtocolos" :customDominios="customDominios"
                                 :multiplos="true"
                                 @selecionar="selecionar($event, 'protocolos')"/>
            </td>
          </tr>
          </tbody>
        </card-table>
      </card>
    </template>
    <auditoria-pagination v-else :referencia="id" operacao="UPDATE, CREATE" entidade="DOCUMENTACAO" />

    <template #footer>
      <button v-if="!auditoria" type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Fechar</button>
      <button v-if="auditoria" type="button" @click.prevent="showAuditorias()" class="btn btn-outline-secondary mr-auto">Voltar</button>
      <v-button v-if="!auditoria && id" :run="showAuditorias" class="btn-outline-primary">Auditoria</v-button>
      <v-button v-if="!auditoria" :run="salvar" class="btn-outline-primary ml-2">Salvar & Continuar</v-button>
    </template>

  </modal>

</template>

<script>
  import AnexoBusiness from "@/business/AnexoBusiness";
  import ListaBusiness from "@/business/crud/ListaBusiness";
  import FrontBusiness from "@/business/FrontBusiness";
  import DocumentacaoBusiness from "@/business/indicadores/DocumentacaoBusiness";
  import utils from "@/commons/Utils";
  import AnexosWrapper from "@/components/Anexos/AnexosWrapper.vue";
  import Card from "@/components/Layout/components/Card.vue";
  import CardTable from "@/components/Layout/components/CardTable.vue";
  import Modal from "@/components/Modal";
  import AuditoriaPagination from "@/v2/components/Auditoria/AuditoriaPagination";
  import DocumentacaoFormulario from "@/components/IndicadorPessoal/Detalhes/DocumentacaoFormulario.vue";

  export default {
    name: "FormularioDocumentacao",
    components: {
      BuscarDocumentacao : () => import("@/components/BuscarDocumentacao"),
      AnexosWrapper, CardTable, Card,
      AuditoriaPagination, Modal},
    props: {
      id: String,
      envolvido: Object,
      protocolo: String,
    },

    modal:{
      width: 700
    },

    computed: {
      isProcuracaoOrEscritura() {
        return DocumentacaoBusiness.isProcuracaoOrEscritura(this.form.tipo);
      },

      isInstrumentoParticular() {
        return DocumentacaoBusiness.isInstrumentoParticular(this.form.tipo);
      },

      isEscritura() {
        return this.form.tipo === 'ESCRITURA';
      },

      isTipoComCamposCartorariosBase() {
        return DocumentacaoBusiness.isTipoComCamposCartorariosBase(this.form.tipo);
      },

      isContratoSocial() {
        return DocumentacaoBusiness.isContratoSocial(this.form.tipo);
      },
    },

    async mounted() {
      this.papeis = this.$root.papeis.filter(p => p.dominios?.includes('DOCUMENTACAO'));
      await this.loadServentias();

      if (this.id) {
        this.loadArquivos();
        this.$set(this, 'form', await DocumentacaoBusiness.getById(this.id));
      }else{
        this.addEnvolvido(this.envolvido);
      }
    },

    data() {
      let customDominios = [
        {id: 'PROTOCOLO_RI', nome: 'Protocolo RI', tipo : 'PROTOCOLO', atribuicao : 'RI', genero: 'o', nomeCompleto: 'Protocolo RI'},
        {id: 'CERTIDAO_RI', nome: 'Certidão RI', tipo : 'PEDIDO_CERTIDAO', atribuicao : 'RI', genero: 'o', nomeCompleto: 'Pedido de Certidão RI'},
      ]
      return {
        arquivos: [],
        files: [],
        form: {
          envolvidos: [],
          documentacoes: [],
          protocolos: [],
          tipo: 'PROCURACAO',
          vencimento: null,
          numero: null,
          livro: null,
          folhaInicial: null,
          folhaFinal: null,
          especie: null,
          serventia: null,
          instituicao: null,
          lavratura: null,
          numeroRegistro: null,
          registro: null,
          arquivamento: null,
          descricao: null,
        },
        validation: {},
        papeis: [],
        tipos: DocumentacaoBusiness.tipos(),
        serventias: [],
        auditoria: false,
        customDominios
      }
    },

    watch: {
      'form.tipo'(newValue) {
        if (newValue !== 'ESCRITURA') {
          this.$set(this.form, 'especie', null);
          this.$set(this.form, 'serventia', null);
        }
      }
    },
    methods: {

      close: FrontBusiness.closeModal,
      nomearProtocolo : FrontBusiness.nomearProtocolo,

      async load(){
        if (this.id) {
          this.loadArquivos();
          this.$set(this, 'form', await DocumentacaoBusiness.getById(this.id));
        }else{
          this.addEnvolvido(this.envolvido);
        }

      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '#formulario-documentacao');
      },

      async salvar() {
        let dto = utils.clone(this.form);

        dto.envolvidos.forEach(e => {
          e.papel = e.papel?.id || e.papel;
        });
        dto.serventia = dto.serventia?.id || dto.serventia;

        dto.protocolos = dto.protocolos?.filter(e => e).map(e => e.id);
        if (this.protocolo) dto.protocolos.push(this.protocolo);
        dto.documentacoes = dto.documentacoes?.filter(e => e && e.id !== dto.id).map(e => e.id);

        let retorno = await DocumentacaoBusiness.save(dto, this.form.id).catch(this.showError)
        if(retorno){
          FrontBusiness.showSuccess('','Documento salvo com sucesso');
          this.$set(this, 'id', retorno.id);
          await this.load();
        }
      },

      async loadArquivos() {
        this.arquivos = await AnexoBusiness.listar('DOCUMENTACAO', this.id);
        this.$nextTick(() => {
          this.files = [];
        });
      },

      async loadServentias() {
        let config = this.$root.config;
        let serventia = await ListaBusiness.getById( config?.listaRegistroAnterior?.id);
        this.$set(this, 'serventias', (serventia || {lista: []}).lista.map(item => ({
          id: item,
          nome: item
        })));
      },

      async inputFile() {
        if (this.files[0]) {
          await AnexoBusiness.inserir(this.files[0].file, 'DOCUMENTACAO', this.form.id)
            .catch((e) => FrontBusiness.showError('', e.message));
          this.loadArquivos();
        }
      },

      addEnvolvido(envolvido){
        this.$nextTick(() => {
          if(!this.form.envolvidos.find(e => e.indicadorPessoalId === envolvido.indicadorPessoalId) && envolvido){
            this.form.envolvidos.push({
              indicadorPessoalVersao: envolvido,
              papel: this.papeis[0]?.id,
              versao: null,
              ordem: 1000,
              tipoPessoa: envolvido?.tipoPessoa,
              nome: envolvido?.nome,
              indicadorPessoalId: envolvido?.indicadorPessoalId,
            });
          }
        });
      },

      remover(idx, lista) {
        this.$nextTick(() => {
          this.form[lista].splice(idx, 1);
        });
      },

      showAuditorias(){
        this.auditoria = !this.auditoria;
      },

      selecionar(itens, lista){
        this.$set(this.form, lista, this.form[lista] || []);
        this.$nextTick(() => {
          itens?.forEach((item) => {
            if(item && !this.form[lista]?.find(e => e.id === item.id)){
              if (lista === 'documentacoes' && item.id === this.form.id) {
                FrontBusiness.showError("", "Não é possível vincular uma documentação a ela mesma.")
                return
              }
              this.form[lista].push(item);
            }
          });
        });
      },

      async formulario(documentacao = {}){
        await FrontBusiness.openModal(DocumentacaoFormulario, { id : documentacao?.id });
      },

    }
  }
</script>

<style lang=scss>

</style>
